module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "vehicles"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Veículos\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Sistema ponto a ponto\n      ")]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "search",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "search-cell not-visible"
  }, [_c('i', {
    staticClass: "icon-search-input"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input-search",
    attrs: {
      "type": "search",
      "name": "",
      "value": "",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.state == 'LOADING') ? _c('div', {
    staticClass: "margin-t20"
  }, [_vm._v("\n        Carregando veículos. Aguarde...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.state == 'LOADED' && _vm.data.itens.length == 0) ? _c('div', {
    staticClass: "alert alert-warning margin-t20"
  }, [_vm._v("\n        Nenhum veículo encontrado.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.itens && _vm.data.itens.length > 0) ? [_c('div', {
    staticClass: "margin-t20 table-white-header",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('table', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "table stripped-odd no-footer",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.data.itens), function(itens) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vehiclesChecked),
        expression: "vehiclesChecked"
      }],
      staticClass: "check-p-to-p",
      attrs: {
        "id": itens.vehicleId,
        "type": "checkbox"
      },
      domProps: {
        "value": itens.vehicleId,
        "checked": Array.isArray(_vm.vehiclesChecked) ? _vm._i(_vm.vehiclesChecked, itens.vehicleId) > -1 : (_vm.vehiclesChecked)
      },
      on: {
        "click": function($event) {
          return _vm.tooglePtoP(itens)
        },
        "change": function($event) {
          var $$a = _vm.vehiclesChecked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = itens.vehicleId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.vehiclesChecked = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.vehiclesChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.vehiclesChecked = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itens.modelName))]), _vm._v(" "), _c('td', {
      staticClass: "cell-plate"
    }, [_c('div', [_vm._v("\n                  " + _vm._s(itens.plate) + "\n                ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itens.categoryAxesName))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('pagination', {
    attrs: {
      "model": _vm.page
    },
    on: {
      "page-change": _vm.setCurrentPage
    }
  })], 1)]), _vm._v(" "), (_vm.data && _vm.data.vehicleList && _vm.data.vehicleList.vehicle) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 result-table-count text-center"
  }, [_vm._v("\n            Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + "\n            a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n            encontrados.\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n              Voltar\n            ")])], 1)])] : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-t30"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n          O Sistema Ponto a Ponto é uma nova modalidade de cobrança de pedágio nas Rodovias Paulistas, feita de forma eletrônica\n          e com base no trecho percorrido pelo motorista. Funciona através de pórticos com antenas distribuídos ao longo da\n          rodovia que fazem a leitura dos dispositivos instalados e o valor cobrado do usuário será de acordo com o trecho\n          percorrido.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n          A adesão ao sistema Ponto a Ponto é feita por veículo, podendo um cliente possuir veículos com ou sem adesão ao\n          sistema Ponto a Ponto.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_c('b', [_vm._v("Regra de Cancelamento:")]), _vm._v(" O cliente pode solicitar o cancelamento ao sistema Ponto a Ponto a qualquer momento.\n          Após o cancelamento, o cliente deve aguardar pelo menos 30 dias para solicitar a adesão novamente do veículo.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_c('b', [_vm._v("Onde funciona?")]), _c('br'), _vm._v("\n          O Ponto a Ponto funciona nas rodovias Engenheiro Constâncio Cintra (SP-360), Santos Dumont (SP-75),\n          Governador Adhemar Pereira de Barros (SP-340) e na Rodovia Prof. Zeferino Vaz (SP 332).\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n          Para solicitar o cadastramento nas rodovias SP075, SP332 e SP360, entre em contato com a concessionária.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n          O Ponto a Ponto na SP340 é aberto para qualquer usuário e qualquer veículo que trafegue na rodovia.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n          Para mais informações sobre o Ponto a Ponto consulte:\n          "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.artesp.sp.gov.br/Style%20Library/extranet/rodovias/sistema-ponto-a-ponto.aspx"
    }
  }, [_vm._v("http://www.artesp.sp.gov.br/Style%20Library/extranet/rodovias/sistema-ponto-a-ponto.aspx")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-purple btn-search not-visible",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v(" adicionar veículo")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Ponto a ponto SP340")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "27%"
    }
  }, [_vm._v("Modelo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8em"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Eixos")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-407104b4!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/vehicles-p-to-p.vue
// module id = 2108
// module chunks = 1